//Paquetes NPM de GYF.
import { Mediator } from 'com-gyf-webcore-mediator';
import { LogHelper } from 'com-gyf-webcore-loghelper';
import { Engine1Proxy, ConciergeProxy } from 'com-gyf-webcore-servicehub';
import ProcessManager from '../../../Common/Managers/ProcessManager';

export const GET_DATA_LISTADO_PARAMETROS = 'GET_DATA_LISTADO_PARAMETROS';
export const GET_DATA_LISTADO_PARAMETROS_RESULT = 'GET_DATA_LISTADO_PARAMETROS_RESULT';
export const RESET_STATE_LISTADO_PARAMETROS = 'RESET_STATE_LISTADO_PARAMETROS';
export const FILTRAR_LISTADO_PARAMETROS = 'FILTRAR_LISTADO_PARAMETROS';
export const SET_ENTIDAD_ID = "SET_ENTIDAD_ID";
export const LIMPIAR_RUTEO_ATLAS = "LIMPIAR_RUTEO_ATLAS";
export const ORDER_COLUMN_FROM_LISTADO_PARAMETROS = 'ORDER_COLUMN_FROM_LISTADO_PARAMETROS';
export const FILTRAR_ENTIDADES_BY_PRODUCTOS_LISTADO_PARAMETROS = 'FILTRAR_ENTIDADES_BY_PRODUCTOS_LISTADO_PARAMETROS';
export const SET_FUNCTIONS_ATLAS = 'SET_FUNCTIONS_ATLAS';
export const GET_ENTIDADES_NOT_SUCCESS = 'GET_ENTIDADES_NOT_SUCCESS';
export const ROUTE_TO_VISTA_INSTANCIA_PARAMETRO = 'ROUTE_TO_VISTA_INSTANCIA_PARAMETRO';

let _dispatch, _routingState = null;

/**
 * Obtiene los datos para popular la pantalla.
 * @param {any} state
 * @param {any} currentScope
 * @param {any} datosSolicitud
 */
export function getDataListadoParametros(currentScope) {
    LogHelper.In(getDataListadoParametros.name, currentScope);
    return (dispatch, getState) => {
        _dispatch = dispatch;

        const state = getState();

        dispatch({ type: GET_DATA_LISTADO_PARAMETROS, state });

        var currentScopeRequest = {
            "UserId": currentScope.UserId,
            "ProductCode": currentScope.ProductCode,
            "ProgramCode": currentScope.ProgramCode
        }

        ConciergeProxy.Execute((data) => {
            _cargaInicialListadoParametros(data);
            LogHelper.Out("getDataVistaInstanciaParametro", data);
        }, null, "GETFUNCTIONS", currentScopeRequest, null, "ATLAS");
    }
}

/**
 * Se ordena la tabla por una columna.
 * @param {any} columnIndex
 */
export function orderColumn(columnName) {
    LogHelper.In(orderColumn.name, columnName);

    return (dispatch) => {
        dispatch({ type: ORDER_COLUMN_FROM_LISTADO_PARAMETROS, columnName });
    }
}

/**
 * Dispara el filtro por el producto seleccionado el en combo.
 * @param {any} productoCodigo
 */
export function selectComboProducto(productoCodigo) {
    LogHelper.In(selectComboProducto.name, productoCodigo);

    return (dispatch) => {
        dispatch({ type: FILTRAR_ENTIDADES_BY_PRODUCTOS_LISTADO_PARAMETROS, productoCodigo: productoCodigo });
    }
}

/**
 * Resetea el estado inicial
 */
export function resetState() {
    LogHelper.In(resetState.name);

    return (dispatch) => {
        dispatch({ type: RESET_STATE_LISTADO_PARAMETROS });
        dispatch({ type: LIMPIAR_RUTEO_ATLAS });
    }
}

/**
 * Setea la entidad correspondiente.
 * @param {any} objEntidad
 */
export function setearEntidad(objEntidad) {
    LogHelper.In(setearEntidad.name, objEntidad);

    objEntidad.rutaVistaInstancia = ProcessManager.GetNextStep("VistaInstanciaParametro", ROUTE_TO_VISTA_INSTANCIA_PARAMETRO);

    return (dispatch) => {
        dispatch({ type: SET_ENTIDAD_ID, ...objEntidad });
    }
}

/**
 * Envia las entidades filtradas a mostrar.
 */
export function findEntidades(filtro) {
    LogHelper.In(findEntidades.name, filtro);

    return (dispatch) => {
        dispatch({ type: FILTRAR_LISTADO_PARAMETROS, filtro: filtro });
    }
}

function _cargaInicialListadoParametros(data) {
    LogHelper.In(_cargaInicialListadoParametros.name, data);

    let functions = data.ATLAS;
    functions ? functions.forEach(p => { functions[p.Codigo_Funcion] = true; }) : functions;


    if (functions.Consulta == true)
        _dispatch({ type: SET_FUNCTIONS_ATLAS, functions });
    else
        _dispatch({ type: GET_ENTIDADES_NOT_SUCCESS });


    LogHelper.Out(_cargaInicialListadoParametros.name, null, 'GET_ENTIDADES', 'Get', 'Atlas', 'Atlas', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_ENTIDADES', 'Get', 'Atlas', 'Atlas', 1, 'Product');
    Engine1Proxy.Execute((data) => _loadInicialListadoParametrosInitialStateData(data));
}

function _loadInicialListadoParametrosInitialStateData(data) {
    LogHelper.In(_loadInicialListadoParametrosInitialStateData.name, data);

    let entidades = JSON.parse(data.GET_ENTIDADES).Recordset0.Rows;
    let equivalencias = JSON.parse(data.GET_ENTIDADES).Recordset1.Rows;
    let productos = JSON.parse(data.GET_ENTIDADES).Recordset2.Rows;

    entidades.forEach(function (entidad) {
        setEquivalencias(entidad, equivalencias);
        setProductos(entidad, productos);
        entidad.mostrar = true;
    })

    let productosFiltrados = productos.reduce((x, y) => x.findIndex(e => e.CODIGO_PRODUCTO == y.CODIGO_PRODUCTO) < 0 ? [...x, y] : x, []);

    productosFiltrados = productosFiltrados.sort(function (a, b) {
        return (a.CODIGO_PRODUCTO > b.CODIGO_PRODUCTO) ? 1 : (a.CODIGO_PRODUCTO < b.CODIGO_PRODUCTO) ? -1 : 0;
    });

    productosFiltrados.unshift({ CODIGO_PRODUCTO: "Seleccione..." });

    productosFiltrados.forEach(function (producto, index) {
        producto.seleccionado = (index == 0);
    });

    _dispatch({ type: GET_DATA_LISTADO_PARAMETROS_RESULT, entidades: entidades, productos: productosFiltrados });
}

function setEquivalencias(entidad, equivalencias) {
    LogHelper.In(setEquivalencias.name, entidad, equivalencias);

    if (!entidad.REQUIERE_EQUIVALENCIA) {
        entidad.equivalencias = "No requiere";
    } else {
        let entidadEquivalencias = equivalencias.filter(x => x.ENTIDAD_ID == entidad.ID);
        if (entidadEquivalencias.length == 0) {
            entidad.equivalencias = "Sin equivalecias";
        }
        else {
            entidad.equivalencias = entidadEquivalencias[0].CODIGO + ", ";
            if (entidadEquivalencias[1] != undefined) {
                entidad.equivalencias += entidadEquivalencias[1].CODIGO;
                if (entidadEquivalencias.length > 2) {
                    entidad.equivalencias += " y " + (entidadEquivalencias.length - 2) + " más";
                }
            }
            else {
                entidad.equivalencias = entidad.equivalencias.substring(0, entidad.equivalencias.length - 2);
            }
        }
    }
}

function setProductos(entidad, productos) {
    LogHelper.In(setProductos.name, entidad, productos);

    let entidadProductos = productos.filter(x => x.ENTIDAD_ID == entidad.ID);
    entidad.productos = entidadProductos;
    if (entidadProductos.length == 0) {
        entidad.productosLabel = "Sin producto";
    }
    else {
        entidad.productosLabel = entidadProductos[0].CODIGO_PRODUCTO + ", ";
        if (entidadProductos[1] != undefined) {
            entidad.productosLabel += entidadProductos[1].CODIGO_PRODUCTO;
            if (entidadProductos.length > 2) {
                entidad.productosLabel += " y " + (entidadProductos.length - 2) + " más";
            }
        }
        else {
            entidad.productosLabel = entidad.productosLabel.substring(0, entidad.productosLabel.length - 2);
        }
    }
}

export function routeToVistaInstanciaParametro(id) {
    return (dispatch) => {
        _routing(id, ROUTE_TO_VISTA_INSTANCIA_PARAMETRO);
    }
}

    function _routing(id, option) {
        if (id) {
            id = JSON.stringify(id);
        }

        let redirectLocation = ProcessManager.GetNextStep("VistaInstanciaParametro", option, id);
        redirectLocation += id ? ( "/" + id) : "";

        _dispatch({ type: ROUTE_TO_VISTA_INSTANCIA_PARAMETRO, data: redirectLocation })
    }


// WEBPACK FOOTER //
// ./Portico/Productos/Atlas/App/Screens/ListadoParametros/actions/Actions.js